/**
 * Trash, as each role sees it.
 *
 * Only admin and staff get a Restore button. The server's restore route refuses everyone else
 * (backend server.py restore_project), and a client was shown a button that always failed, so
 * a client is told how to get something back instead. Billing never had the button and still
 * does not (operator, 2026-09-23).
 */
export const canRestoreFromTrash = (user) => user?.role === 'admin' || user?.role === 'staff';

export const TRASH_HELP_EMAIL = 'hello@uncutgems.com';
export const TRASH_HELP_LEAD = 'Need something back? Email us at';
